export default __webpack_public_path__ + "273c343df573f80618d5cd631978da7a.coffee";